import { z } from 'zod';
import { oneOf } from '../../navigation/searchParams';

/** Which page sent the user here, for the trail back. */
export const topupSearch = z.object({
  from: oneOf(['usage', 'billing']),
});
